import { ROTA_APIS } from "@/api_framework/api_config";
import { IRotaManagementShiftListData, IRotaManagementShiftUpdateResponse } from "@/api_framework/api_modals/Rota";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});
export type RotaCreationReturnType = {
  status: boolean;
  message: string;
};

export const useRotaShiftUpdateAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const dispatch = useAppDispatch();
  const execute = useCallback(
    async (filterParams: IRotaManagementShiftListData, shiftId: string) => {
      dispatch(
        setLoading({
          key: "isPWLInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: RotaCreationReturnType = await axios
          .put(ROTA_APIS?.ROTA_SHIFT_UPDATE?.baseURL ?? "", filterParams, {
            params: { id: shiftId },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IRotaManagementShiftUpdateResponse>) => {
            if (res.data.status === true) {
              toast.success(`${filterParams?.shift_name} Standard Shift has been updated successfully.`);
              return { status: true, message: "Updated" };
              //IF COND
            } else {
              return { status: true, message: "Updated" };
              //ELSE COND
              // return { status: false, message: "Updation Faield" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            const vv = e.response.data as any;
            return { status: true, message: vv?.message };
          });
        return response;
      } catch (e: any) {
        const vv = e.response.data as any;
        toast.error("Server Error: " + e.message);
        return { status: false, message: vv.message };
      }
    },
    [dispatch],
  );
  return execute;
};
